import React from "react";
import ls from "@livesession/browser";
import { useAuth0 } from "@auth0/auth0-react";

export const useLiveSession = () => {
  const { user } = useAuth0();

  React.useEffect(() => {
    if (
      window.location.hostname === "aida.tools" ||
      window.location.hostname === "www.aida.tools" ||
      window.location.hostname === "app.v2.staging.aida.tools"
    ) {
      const liveSessionId = process.env.REACT_APP_LIVE_SESSION_ID;
      if (!liveSessionId) {
        console.warn(
          "Live Session ID is not set. Skipping Live Session initialization."
        );
        return;
      }
      ls.init(liveSessionId);
      ls.newPageView();
      if (user) {
        ls.identify({ name: user.name, email: user.email });
      }
    }
  }, []);

  return null;
};
